import { Component, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';
import { IWaiters } from '../../interfaces/IWaiters';
import Swal from 'sweetalert2';
import { AuthService } from '../../services/auth.service';
import { AlertService } from '../../services/alert.service';
import { TranslateKeysService } from '../../services/translate-keys.service';
import { OfflineCrud } from 'src/app/services/offline-crud.service';

@Component({
  selector: 'app-waiter-login',
  templateUrl: './waiter-login.component.html',
  styleUrls: ['./waiter-login.component.css'],
})
export class WaiterLoginComponent implements OnInit {
  userData = {
    password: '',
    startedShift: Date(),
  };
  waiterObject;

  constructor(
    public alertService: AlertService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private api: DataService,
    private autoLogout: AuthService,
    private translateKeys: TranslateKeysService,
    private offlineService: OfflineCrud
  ) {}

  ngOnInit(): void {
    this.waiterObject = JSON.parse(localStorage.getItem('waiterObject'));
  }

  /**
   * each time a user clicks on the numpad we pass the value to userData.password
   * the numpad password input is an ngModel to userData.password
   * @param numValue
   */
  type(numValue: number) {
    if (this.userData.password.length < 4) {
      this.userData.password += numValue;
    } else {
      return 'Length allowed only 4 max elements';
    }
  }

  /**
   * Each time the user presses X button on numpad we slice(remove) the last item
   */
  resetInput(): any {
    const oldpw = this.userData.password;
    const newpw = oldpw.slice(0, -1);
    this.userData.password = newpw;
  }

  /**
   * when the users clicks Enter Button ( > ) in numpad we pass the pin to this function
   * if succeeded we redirect the user to the next route
   * if not we display an error with wrong pin
   * @param pin
   */
  loginPin(pin: string) {
    const parsedPin = parseInt(pin, 10);
    const waiterID = this.api.getWaiterID();
    if (pin === null || pin === '') {
      this.alertService.swalFire(
        'info',
        this.translateKeys.doTranslate('EMPTY_PIN'),
        true,
        false,
        'OK',
        '',
        2000
      );
      return;
    } else if (waiterID === null || waiterID === '') {
      this.alertService.swalFire(
        'error',
        this.translateKeys.doTranslate('LOGIN_ERROR'),
        true,
        false,
        'Mbyll',
        '',
        1000
      );
      const token = localStorage.getItem('token');
      this.router.navigate(['/'], { queryParams: { token } });
    } else {
      this.alertService.swalAutoLoader();
      if (this.offlineService.isOnline()) {
        this.api.loginPIN(waiterID, parsedPin).subscribe(
          (response: any) => {
            // @ts-ignore
            if (response.value.status === 200) {
              this.waiterObject.fiscalType = response.value.user.fiscalType;
              localStorage.setItem(
                'waiterObject',
                JSON.stringify(this.waiterObject)
              );
              this.autoLogout.autoLogout();
              this.router.navigate(['dashboard'], {
                relativeTo: this.activeRoute,
              });
            }
            Swal.close();
          },
          (error) => {
            if (error.status === 401) {
              this.alertService.swalFire(
                'error',
                this.translateKeys.doTranslate('WRONG_PIN'),
                false,
                true,
                '',
                this.translateKeys.doTranslate('CLOSE')
              );
              this.userData.password = '';
            }
          }
        );
      } else {
        this.offlineService
          .getWaitersFromLocalDb()
          .then((waiters: IWaiters[]) => {
            var waiter = waiters.find(
              (w) => w.id == waiterID && w.pin == parsedPin
            );
            if (waiter) {
              this.autoLogout.autoLogout();
              this.router.navigate(['dashboard'], {
                relativeTo: this.activeRoute,
              });
            } else {
              this.alertService.swalFire(
                'error',
                this.translateKeys.doTranslate('WRONG_PIN'),
                false,
                true,
                '',
                this.translateKeys.doTranslate('CLOSE')
              );
              this.userData.password = '';
            }
            Swal.close();
          });
      }
    }
  }
}
